$(function () {
    if ($('#topArticles__carousel').length) {
        $('#topArticles__carousel').slick({
            rows: 0,
            arrows: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            fade: true
        })
    }
});